var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1096 2.53589C6.33257 2.53589 1.64941 7.21904 1.64941 12.9961C1.64941 18.7731 6.33257 23.4563 12.1096 23.4563C17.8867 23.4563 22.5699 18.7731 22.5699 12.9961C22.5698 7.21904 17.8866 2.53589 12.1096 2.53589ZM9.31881 18.0531H7.02217V10.6333H9.31881V18.0531ZM8.15955 9.66164C7.40949 9.66164 6.80143 9.04862 6.80143 8.29256C6.80143 7.53641 7.40957 6.92344 8.15955 6.92344C8.90952 6.92344 9.51757 7.53641 9.51757 8.29256C9.51762 9.04867 8.90956 9.66164 8.15955 9.66164ZM17.9255 18.0531H15.64V14.1583C15.64 13.0901 15.2342 12.4938 14.3895 12.4938C13.4702 12.4938 12.99 13.1149 12.99 14.1583V18.0531H10.7873V10.6333H12.99V11.6326C12.99 11.6326 13.6526 10.407 15.2259 10.407C16.7992 10.407 17.9255 11.3677 17.9255 13.355L17.9255 18.0531Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinked);
export default __webpack_public_path__ + "static/media/linked.f125d8bf29a608138e75fcbb0721e4e4.svg";
export { ForwardRef as ReactComponent };